import React from 'react'
import { BrowserRouter, Switch, Route } from 'react-router-dom'
import EmergencyRoom from './pages/EmergencyRoom'
import LogIn from './components/LogIn'
import PrivateRoute from './components/PrivateRoute'

const Routes = () => (
  <BrowserRouter>
    <Switch>
      <Route path="/" exact component={LogIn} />
      <PrivateRoute path="/inicio" exact component={EmergencyRoom} />
    </Switch>
  </BrowserRouter>
)

export default Routes
